import { ReactNode } from "react";
import { Button } from "./button";
import { BorderBeam } from "./border-beam";
import { ArrowRight } from "lucide-react";

interface BeamButtonProps {
  children: ReactNode;
  size?: "default" | "sm" | "lg";
  className?: string;
  showArrow?: boolean;
  fullWidth?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
}

export function BeamButton({
  children,
  size = "lg",
  className = "",
  showArrow = false,
  fullWidth = false,
  onClick,
  disabled = false,
  type = "button",
}: BeamButtonProps) {
  return (
    <div
      className={`relative rounded-lg p-px overflow-hidden bg-transparent ${
        fullWidth ? "w-full" : "w-full sm:w-auto"
      }`}
    >
      <Button
        type={type}
        size={size}
        className={`relative z-10 w-full bg-background text-foreground font-semibold hover:bg-background/80 transition-colors rounded-[calc(var(--radius)-1px)] ${className}`}
        onClick={onClick}
        disabled={disabled}
      >
        {children}
        {showArrow && <ArrowRight className="ml-2 h-4 w-4" />}
      </Button>
      <BorderBeam duration={3} colorTo="hsl(var(--primary))" />
    </div>
  );
}
